
import { defineComponent, PropType, onUpdated, ref, computed } from 'vue'
import { View } from '@/models/view'
import { RouteRecordName, useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'NavigationDropDownTab',
  props: {
    values: {
      type: Object as PropType<View[]>,
      required: true
    },
    parent: {
      type: Object
    },
    active: {
      type: String,
      required: true
    }
  },
  emits: ['click'],
  setup (props, { emit }) {
    const options = props.values.map(v => ({label: v.name, value: v}))

    const activeView = computed({
      get: () => props.values.find(view => view.name === props.active),
      set: (value) => {
        emit('click', value)
      }
    })

    // onUpdated(() => {
    //   emit(
    //     'click',
    //     props.values.filter((view) => view.name === currentView.value)[0]
    //   )
    // })

    return {
      activeView,
      options,
      contentWidth: computed(() => {
        return options.map(n => n.label).reduce((s,n) => s.length > n.length ? s : n,'').length * 12
      })
    }
  }
})
